import { fromJS } from 'immutable';
import { endLoad, startLoad } from 'portaltransparencia-common/crud/Core.js';

import * as types from './Types.js';

const initialState = fromJS({
  totalacesso: {}
});

function totalAcessoReducer(state = initialState, action) {
  switch (action.type) {
    case types.TOTALACESSOS_START: {
      return startLoad(state);
    }

    case types.TOTALACESSOS_SUCCESS: {
      return endLoad(state.set('totalacesso', fromJS(action.payload)));
    }

    case types.TOTALACESSOS_ERROR: {
      return endLoad(state);
    }
  }

  return state;
}

export default totalAcessoReducer;
